import { inject, Injectable } from '@angular/core';
import { AccessControlFacade, PermissionsFacade, Permissions } from '@p2p/access-control/domain';
import { UserRole } from '@p2p/users/domain';

@Injectable()
export class PermissionsApiService {
    private readonly accessControlFacade = inject(AccessControlFacade);
    private readonly permissionsFacade = inject(PermissionsFacade);

    permissions$ = this.accessControlFacade.permissions$;

    loadPermissions(role: UserRole): void {
        this.accessControlFacade.loadPermissions(role);
    }

    hasPermissions(permissions: Permissions[]) {
        this.permissionsFacade.hasPermissions(permissions);
    }

    hasPermission(permission: Permissions) {
        this.permissionsFacade.hasPermission(permission);
    }
}
